import { LinearGradient, Path } from "@progress/kendo-drawing";

export const BAR_PALETTES = {
    blue: { light: "#b9daff", mid: "#529fff", dark: "#175ee9" },
    teal: { light: "#b5eee3", mid: "#38cbb0", dark: "#078d7b" },
    violet: { light: "#e0d5ff", mid: "#a48afa", dark: "#7650d6" },
    amber: { light: "#ffe4b5", mid: "#f9b44c", dark: "#cf8116" },
    rose: { light: "#ffd1df", mid: "#f57ca5", dark: "#d33a74" },
    cyan: { light: "#bceef5", mid: "#44bfd5", dark: "#10869d" },
};

function extraPalette(index) {
    const hue = (index * 137.508) % 360;
    const color = lightness => "#" + [0, 8, 4].map(channel => {
        const k = (channel + hue / 30) % 12;
        const a = 0.68 * Math.min(lightness, 1 - lightness);
        return Math.round(255 * (lightness - a * Math.max(-1, Math.min(k - 3, 9 - k, 1))))
            .toString(16).padStart(2, "0");
    }).join("");
    return { light: color(0.87), mid: color(0.62), dark: color(0.43) };
}

export function productBarSeries(categories, series) {
    const palettes = Object.values(BAR_PALETTES);
    return (categories || []).map((name, index) => {
        const palette = palettes[index] || extraPalette(index);
        const value = (series || []).reduce((total, item) => total + (Number(item.data?.[index]) || 0), 0);
        return {
            name,
            color: palette.dark,
            // Stacking centres one coloured bar on each product category.
            data: categories.map((_, category) => category === index ? value : null),
            visual: gradientBarVisual(series, palette),
        };
    });
}

function mix(from, to, amount) {
    return "#" + [1, 3, 5].map(index => Math.round(
        parseInt(from.slice(index, index + 2), 16) * (1 - amount)
        + parseInt(to.slice(index, index + 2), 16) * amount
    ).toString(16).padStart(2, "0")).join("");
}

export function gradientBarVisual(series, palette = BAR_PALETTES.blue) {
    const maximum = Math.max(1, ...(series || []).flatMap(item => item.data || []).map(value => Math.abs(Number(value) || 0)));
    return event => {
        const rect = event.rect;
        if (!rect || !Number(event.value) || rect.size.height <= 0) return event.createVisual();
        const intensity = Math.min(1, Math.abs(Number(event.value)) / maximum);
        const fill = new LinearGradient({
            start: [0, 0], end: [0, 1],
            stops: [
                { offset: 0, color: mix(palette.mid, palette.dark, intensity) },
                { offset: 1, color: mix(palette.light, palette.mid, intensity * 0.4) },
            ],
        });
        const { x, y } = rect.origin;
        const { width, height } = rect.size;
        const radius = Math.min(6, width / 3, height / 2);
        return new Path({ fill, stroke: null })
            .moveTo(x, y + height)
            .lineTo(x, y + radius)
            .curveTo([x, y], [x, y], [x + radius, y])
            .lineTo(x + width - radius, y)
            .curveTo([x + width, y], [x + width, y], [x + width, y + radius])
            .lineTo(x + width, y + height)
            .close();
    };
}
